import { withRouter } from 'react-router';
import ApolloErrorSection from './ApolloErrorSection';

export default withRouter(ApolloErrorSection);
